import { render, staticRenderFns } from "./recordCom.vue?vue&type=template&id=69238f42&scoped=true&"
import script from "./recordCom.vue?vue&type=script&lang=js&"
export * from "./recordCom.vue?vue&type=script&lang=js&"
import style0 from "./recordCom.vue?vue&type=style&index=0&id=69238f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69238f42",
  null
  
)

export default component.exports